import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://reload-nutrition.com';
const SITE_NAME = 'RELOAD Nutrition';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_reload-performance/artifacts/uu3trnls_Render_Mockup_1920_1920_2026-03-14-2.jpg';

export default function SEO({ title, description, canonical, schema, ogImage }) {
  const fullTitle = title
    ? `${title} | RELOAD Nutrition`
    : 'RELOAD | Increase Semen Volume & Ejaculate More | Natural Supplement UK';

  const fullCanonical = canonical ? `${SITE_URL}${canonical}` : SITE_URL;
  const socialImage = ogImage || DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* Core */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:width" content="1264" />
      <meta property="og:image:height" content="848" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialImage} />

      {/* Structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
